@if ((items?.length || 0) > 0) {
  <div class="submenu-level-2">
    <ul nz-menu [nzMode]="'horizontal'">
      @for (item of items; track item.url) {
        @if (hasAccess(item)) {
          <li class="ant-menu-item ng-star-inserted" routerLinkActive="ant-menu-item-selected">
            <a routerLink="{{ item.url }}" title="{{ item.title }}">
              <span class="title">{{ item.title }}</span>
            </a>
          </li>
        } @else {
          @if (display(item)) {
            <li class="ant-menu-item ng-star-inserted">
              <a title="{{ item.title }}" class="disabled">
                <span class="title">{{ item.title }}</span>
              </a>
            </li>
          }
        }
      }
    </ul>
  </div>
}
